module.exports = __webpack_public_path__ + "img/first-block-img-mobile.db73bf83.png";